import { DataSensitivity } from "../types";

export const DATA_SENSITIVITY_OPTIONS = Object.values(DataSensitivity);

export const DATA_SENSITIVITY_LABELS: Record<DataSensitivity, string> = {
  [DataSensitivity.PUBLIC]: "Public",
  [DataSensitivity.INTERNAL]: "Internal",
  [DataSensitivity.CONFIDENTIAL]: "Confidential",
  [DataSensitivity.PII]: "PII",
  [DataSensitivity.PCI]: "PCI",
  [DataSensitivity.HIPAA]: "HIPAA",
};

export function dataSensitivityLabel(value: DataSensitivity): string {
  return DATA_SENSITIVITY_LABELS[value] ?? value;
}
